import { colors } from '@styles/vars/colors.style'
import styled from 'styled-components'

export const HeroMain = styled.section`
  color: ${colors.white};
  background-color: ${colors.charcoal};
`
